import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Dialog,
  AppBar,
  Container,
  Toolbar,
  IconButton,
} from "@material-ui/core";
import { ButtonProps } from "@material-ui/core/Button";
import {
  Close as CloseIcon,
  LibraryAdd as LibraryAddIcon,
} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  header: {
    position: "relative",
    fontSize: "1.5rem",
    "& button": {
      marginRight: theme.spacing(2),
    },
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}));

interface Props {
  children?: React.ReactNode;
  title?: React.ReactNode;
  buttonHidden?: boolean;
  buttonText?: React.ReactNode;
  open: boolean;
  onOpen?: () => void;
  onClose?: () => void;
  ButtonProps?: ButtonProps;
}

export default ({
  children,
  title,
  buttonHidden,
  buttonText,
  open,
  onOpen,
  onClose,
  ButtonProps,
}: Props) => {
  const styles = useStyles();
  return (
    <>
      {!buttonHidden && (
        <Button
          variant="text"
          color="primary"
          startIcon={<LibraryAddIcon />}
          onClick={onOpen}
          {...ButtonProps}
        >
          {buttonText || "新規作成"}
        </Button>
      )}
      <Dialog fullScreen open={open} onClose={onClose}>
        <AppBar className={styles.header} color="default">
          <Toolbar>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
            {title}
          </Toolbar>
        </AppBar>
        <Container className={styles.container} maxWidth="sm">
          {children}
        </Container>
      </Dialog>
    </>
  );
};
